<template>
    <div
        :class="[
            'emp',
            { open: openEmployeeMenuScenarioId === scenario.scenarioId },
        ]"
    >
        <div class="emp-chips">
            <span v-if="selectedStaff.length === 0" class="emp-empty">Все сотрудники</span>
            <span v-for="employee in selectedStaff" :key="employee.id" class="emp-chip">
                {{ employee.name }}
                <button type="button" aria-label="Убрать" @click="$emit('remove', employee.id)">
                    &times;
                </button>
            </span>
        </div>
        <button type="button" class="emp-add" @click.stop="$emit('toggle-menu')">+ сотрудник</button>
        <div class="emp-menu" @click.stop>
            <div
                v-for="employee in availableStaff"
                :key="employee.id"
                class="emp-opt"
                @click="$emit('pick', employee.id)"
            >
                {{ employee.name }}
            </div>
            <div v-if="availableStaff.length === 0" class="emp-menu-empty">Все добавлены</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StarterPackEmployeePicker',
    props: {
        scenario: {
            type: Object,
            required: true,
        },
        selectedStaff: {
            type: Array,
            default: () => [],
        },
        availableStaff: {
            type: Array,
            default: () => [],
        },
        openEmployeeMenuScenarioId: {
            type: [Number, String, null],
            default: null,
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/vars.sass';

.emp-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 9px;
    color: $main-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 12px;
    font-weight: 600;
    background: $bcg-card-new;
    border-radius: 7px;
}

.emp-chip button {
    padding: 0;
    color: inherit;
    font-size: 14px;
    line-height: 1;
    background: none;
    border: 0;
    cursor: pointer;
    opacity: 0.6;
}

.emp-chip button:hover {
    opacity: 1;
}

.emp {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 7px;
}

.emp-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.emp-empty {
    color: $muted-light-new;
    font-size: 12px;
}

.emp-add {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 5px 11px;
    color: $main-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    background: #fff;
    border: 1.4px dashed #c7cdda;
    border-radius: 7px;
    transition: 0.15s;
}

.emp-add:hover {
    background: $bcg-card-new;
    border-color: $main-new;
}

.emp-menu {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    z-index: 6;
    display: none;
    min-width: 230px;
    max-height: 210px;
    padding: 5px;
    overflow-y: auto;
    background: #fff;
    border: 1px solid $border-new;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(26, 26, 46, 0.14);
}

.emp.open .emp-menu {
    display: block;
}

.emp-opt {
    padding: 9px 11px;
    color: $text-color-new;
    font-size: 13px;
    border-radius: 7px;
    cursor: pointer;
}

.emp-opt:hover {
    background: $bcg-card-new;
}

.emp-menu-empty {
    padding: 11px;
    color: $muted-light-new;
    font-size: 12.5px;
    text-align: center;
}
</style>
